import { render, staticRenderFns } from "./ProfileNonIdentStandardVolunteerForm.vue?vue&type=template&id=22e5a37a&scoped=true"
import script from "./ProfileNonIdentStandardVolunteerForm.vue?vue&type=script&lang=ts"
export * from "./ProfileNonIdentStandardVolunteerForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileNonIdentStandardVolunteerForm.vue?vue&type=style&index=0&id=22e5a37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5a37a",
  null
  
)

export default component.exports